<div fxFlex="100" fxLayout="column" fxLayoutAlign="center center">
  <img [src]="image" class="not-found__img" alt="{{ title }}" />
  <div class="not-found__title">{{ title }}</div>
  <div class="not-found__subtitle">{{ subtitle }}</div>
</div>
